/**
 * @file 已选知识库结构化数据（inline @ 引用，不再渲染顶栏 Tag）
 */

/** 已选知识库引用（提交 / prune / 插入文案用） */
export interface ISelectedKnowledgeTagData {
  /** 知识库 ID */
  kbId: string;
  /** 知识库名称 */
  kbName: string;
  /** 空间 ID（tenant_id，用于 db_args.kbs） */
  tenantId?: string;
  /** 文档 ID（全文引用时为空） */
  docId?: string;
  /** 文档名称（全文引用时为空） */
  docName?: string;
  /** 原始文件名称（file_name，用于 db_args.kbs.file_list） */
  fileName?: string;
  /** 文件类型（用于 db_args.kbs.file_list） */
  fileType?: string;
}

/**
 * 唯一标识 `${kbId}_${docId ?? docName ?? 'all'}`，按需计算，不作为字段冗余存储。
 * docId 缺失但 docName 存在时（如历史文案中已删除的文档）用 docName 兜底，避免误判为整库引用。
 */
export const getKnowledgeTagKey = (
  item: Pick<ISelectedKnowledgeTagData, 'kbId' | 'docId' | 'docName'>,
): string => `${item.kbId}_${item.docId ?? item.docName ?? 'all'}`;
